import { IStyle } from 'Styles';
import { CustomCheckBox } from 'components/input';
import React, { useState } from 'react';

const RotateCanvasModal = (props: any) => {
  const { onChange } = props;
  const [isChecked, setIsChecked] = useState<boolean>(false);

  return (
    <>
      {`Please note that this rotated screen will have to be manually repaired if there are any changes or fixes in original screen`}
      <CustomCheckBox
        onChange={(e) => {
          onChange(e, isChecked, setIsChecked);
        }}
        id='rotatecanvasmodal-labels'
        label={'Don’t show me again'}
        checked={isChecked}
        mainContainerStyle={styles.rotateCanvasMessageContainer}
        labelStyle={styles.rotateCanvasMessageLabel}
        disabled={false}
      />
    </>
  );
};

const styles: IStyle = {
  rotateCanvasMessageContainer: {
    marginLeft: '0.5rem',
  },
  rotateCanvasMessageLabel: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    marginLeft: '0.75rem',
  },
};

export default RotateCanvasModal;
